/**
 * DeleteImageModal Component
 * 
 * Extracted from HierarchyStep - modal for delete/replace image confirmation.
 */
import React from 'react';

export default function DeleteImageModal({
    isOpen = false,
    url = null,
    assetName = null,
    isSession = false,
    loading = false,
    onReplace,        // () => void
    onDelete,         // (deleteLinkedEntities: boolean) => void
    onClose           // () => void
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-slate-800 border border-slate-600 rounded-xl shadow-2xl max-w-md w-full p-6 space-y-4 animate-in zoom-in-95 duration-200">
                <div className="flex items-start gap-4">
                    <div className="bg-red-900/40 p-3 rounded-full shrink-0">
                        <span className="text-2xl">⚠️</span>
                    </div>
                    <div>
                        <h3 className="text-xl font-bold text-white">Afbeelding Verwijderen</h3>
                        <p className="text-slate-300 text-sm mt-1">
                            Je staat op het punt een afbeelding te verwijderen.{' '}
                            {assetName ? (
                                <>
                                    Deze afbeelding is gekoppeld aan het asset <strong className="text-white">"{assetName}"</strong>.
                                </>
                            ) : (
                                "Deze actie kan niet ongedaan worden gemaakt."
                            )}
                        </p>
                    </div>
                </div>

                <div className="bg-slate-900/50 p-3 rounded border border-slate-700/50 text-xs text-slate-400 space-y-1">
                    <p>• <strong>Vervangen:</strong> Behoudt asset & werkplannen, maar update de foto.</p>
                    <p>• <strong>Definitief Verwijderen:</strong> {assetName ? "Verwijdert foto + asset + gekoppelde werkplannen." : "Verwijdert de foto permanent."}</p>
                </div>

                <div className="flex flex-col gap-2 pt-2">
                    <button
                        onClick={onReplace}
                        className="btn btn-primary w-full flex items-center justify-center gap-2"
                        disabled={loading}
                    >
                        🔄 Afbeelding Vervangen
                    </button>

                    <button
                        onClick={() => onDelete(true)}
                        className="btn bg-red-600 hover:bg-red-700 text-white w-full flex items-center justify-center gap-2 border-none"
                        disabled={loading}
                    >
                        🗑️ Definitief Verwijderen
                    </button>

                    <button
                        onClick={onClose}
                        className="btn btn-ghost w-full"
                        disabled={loading}
                    >
                        Annuleren
                    </button>
                </div>
            </div>
        </div>
    );
}
